var map = {
	"./1.png": "5e80",
	"./10.png": "da8a",
	"./11.png": "5ed2",
	"./12.png": "db84",
	"./2.png": "38cb",
	"./3.png": "fe8f",
	"./4.png": "633f",
	"./5.png": "041b",
	"./6.png": "44b3",
	"./7.png": "414c",
	"./8.png": "0cff",
	"./9.png": "6b18",
	"./Dior.png": "ef9f",
	"./SKII.png": "8ba6",
	"./ali.png": "2ffb",
	"./benchi.png": "cee43",
	"./bmw.png": "f144",
	"./chanel.png": "e4eb",
	"./coco.png": "cc45",
	"./icon／1.png": "eab7",
	"./icon／2.png": "1889",
	"./loreal.png": "24de",
	"./mengniu.png": "eeaf",
	"./wph.png": "7dd5",
	"./xzld.png": "4ec5",
	"./y1.png": "3f62",
	"./y2.png": "9897",
	"./y3.png": "41bf",
	"./y4.png": "06c6",
	"./zg-nongyebank.png": "586f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "88d9";